// extracted by mini-css-extract-plugin
export default {"container":"WarehouseReceiving_container__QVXNU"};